import React, {useEffect, useState} from 'react';
import '../App.css';
import Axios from 'axios';
import { useNavigate } from "react-router-dom";
import GrillaEmpresa from './grillaEmpresa'
import Bodyheaderloged from './bodyheaderloged'
import { Alert } from 'react-bootstrap';

function Bodyempresas (props){
    const navigate = useNavigate();
    const [empresas, setEmpresas] = useState([])
    const [rutempresa, setRutEmpresa] = useState('')
    const [nombreempresa, setNombreEmpresa] = useState('')
    const [direccionempresa, setDireccionEmpresa] = useState('')
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);
    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')
    let statuscall = ''

    const createEmpresa = async (e) =>{
        setClassWaitProcess('waitProcessV')
        if(rutempresa != '')
        {
            if(nombreempresa != '')
            {
                if(direccionempresa != '')
                {
                    let authcode = window.localStorage.getItem('MY_APP_STATE_AUTHCODE').replace('"', '')
                    const data = {   
                        rut: rutempresa,
                        nombre: nombreempresa,
                        direccion: direccionempresa
                    };
            
                    const empresaCreate = await Axios.post(process.env.REACT_APP_URLCREATEENTERPRISE, data, {
                        timeout: process.env.REACT_APP_TIMEOUT,
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                        }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                            
                        if(statuscall.status == 200)
                        {
                            setClassWaitProcess('waitProcess')
                            empresas.push(data);
                            let copyempresas = empresas 
                            setEmpresas(copyempresas)
                            setRutEmpresa('')
                            setNombreEmpresa('')
                            setDireccionEmpresa('')

                            setClassWaitProcess('waitProcess')
                            setTituloAlert('Ingreso de empresas')
                            setTextoAlert('Empresa agregada')
                            setClaseAlert('success alertFlotante opacity-100')
                            setAlert(true)

                            setTimeout(() => {
                                setAlert(false)
                                navigate('/Empresas/' + authcode.replace('"', ''))
                            }, 4000)
                        }
                        else
                        {
                            if(statuscall.status == 0)
                            {
                                setClassWaitProcess('waitProcess')
                                setTituloAlert('Ingreso de empresas')
                                setTextoAlert('Servidor no responde. Intentelo mas tarde')
                                setClaseAlert('danger alertFlotante opacity-100')
                                setAlert(true)
                                setTimeout(() => {
                                    setAlert(false)
                                }, 4000)
                            }
                        }
                }
                else
                {
                    setClassWaitProcess('waitProcess')
                    setTituloAlert('Ingreso de empresas')
                    setTextoAlert('Debe ingresar una dirección')
                    setClaseAlert('warning alertFlotante opacity-100')
                    setAlert(true)
                    setTimeout(() => {
                        setAlert(false)
                    }, 4000)   
                }
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert('Ingreso de empresas')
                setTextoAlert('Debe ingresar un nombre')
                setClaseAlert('warning alertFlotante opacity-100')
                setAlert(true)
                setTimeout(() => {
                    setAlert(false)
                }, 4000)   
            }
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert('Ingreso de empresas')
            setTextoAlert('Debe ingresar un rut')
            setClaseAlert('warning alertFlotante opacity-100')
            setAlert(true)
            setTimeout(() => {
                setAlert(false)
            }, 4000)   
        }
    }

    const handleRut = async (e) =>{
        // Despejar Puntos
        let valor = e.target.value.replace('.','');
        // Despejar Guión
        valor = valor.replace('-','');
        
        // Aislar Cuerpo y Dígito Verificador
        let cuerpo = valor.slice(0,-1);
        let dv = valor.slice(-1).toUpperCase();
        setRutEmpresa(cuerpo + '-'+ dv)
    }

    const handleNombre = async (e) =>{
        setNombreEmpresa(e.target.value)
    }

    const handleDireccion = async (e) =>{
        setDireccionEmpresa(e.target.value)
    }

    useEffect(() => {
        Axios.get(process.env.REACT_APP_URLGETENTERPRISES, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setEmpresas(response.data.enterprises)
        }).catch(error => {
            return error     
        });        
    },[]);

    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>

                    <div className='row'>
                    
                        <div className='col col-lg-8 col-md-8 col-sm-12'>
                            <div className='row'>

                                <div className='col col-lg-5 col-md-5 col-sm-12 divAbsolute'>
                                    <div className={classWaitProcess}>
                                        <div className='loaderS'>
                                        </div>
                                    </div>
                                </div>

                                <div className='col col-lg-5 col-md-5 col-sm-12 divAbsolute'>
                                    {alert
                                    ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                                        <Alert.Heading>{tituloAlert}</Alert.Heading>
                                            <p>
                                                {textoAlert}
                                            </p>
                                    </Alert>
                                    :''
                                    }
                                </div>


                                <div className='col col-lg-12 col-md-8 col-sm-12'>
                                    <div className='boSeccionForm'>
                                        <div className='boSeccionFormTitle'>
                                            Agregar nueva empresa
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Rut empresa
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={rutempresa} onChange={handleRut}></input>
                                            </div>
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Nombre empresa
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={nombreempresa} onChange={handleNombre}></input>
                                            </div>
                                        </div>
                                        <div className='boControlForm'>
                                            <div className='boControlFormTitulo'>
                                                Direccion empresa
                                            </div>
                                            <div className='boControlFormContent'>
                                                <input type="text" value={direccionempresa} onChange={handleDireccion}></input>
                                            </div>
                                            <div className='boControlFormAditionalContent'>
                                                <button onClick={createEmpresa}>
                                                    Crear
                                                </button>
                                            </div>                                    
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='col col-lg-12 col-md-8 col-sm-12'>
                                    <GrillaEmpresa/>
                                </div>

                            </div>
                        </div>
                     

                    
                    </div>

                </div>
            </div>
        </div>            
    )
}
export default Bodyempresas